"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ContainerLoader.css");
var ContainerLoader = /** @class */ (function (_super) {
    __extends(ContainerLoader, _super);
    function ContainerLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContainerLoader.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: [styles.containerLoader, this.props.options.className].join(' ') },
            React.createElement("div", { className: styles.spinnerGradWrap },
                React.createElement("div", { className: styles.spinnerSpinnerGrad }, "Loading..."))));
    };
    ContainerLoader.defaultProps = {
        options: {
            className: '',
        },
    };
    return ContainerLoader;
}(React.Component));
exports.default = ContainerLoader;
//# sourceMappingURL=ContainerLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ContainerLoader/ContainerLoader.js
// module id = 196
// module chunks = 8